import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";
const Portfolio = () => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  const [isOpen, setIsOpen] = useState(false);

  const htmlElement = document.getElementsByTagName("html")[0];
  const isRtl = htmlElement.getAttribute("dir") === "rtl";

  const filters = {
    SOFTWARE: "Software Develop",
    WEB: "Web Develop",
    APP: "Mobile App Develop",
  };

  const types = {
    IMAGE: "image",
    DOCUMENT: "document",
  };

  const projectsData = [
    {
      title: "Elderly Kingdom",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "It is a forum website, a website providing a variety of information regarding aging and dementia. My groupmate and I decided to use PHP, SQL, HTML5, Javascript, CSS to develop this website. The user can post whatever topics they want and the topics will be divided to different categories. Additionally, there are various level of users, which mean different levels of users can have different right in this web.",
        client: "",
        technologies: "PHP, SQL, HTML5, Javascript, CSS",
        industry: "Health Care / Social Media",
        date: "December, 2018",
        url: {
          name: "Github",
          link: "https://github.com/dennisisk/Elderly-Kingdom",
        },
        sliderImages: [
          "images/projects/project-elderly-kingdom2.jpg",
          "images/projects/project-elderly-kingdom3.jpg",
          "images/projects/project-elderly-kingdom4.jpg",
        ],
      },

      thumbImage: "images/projects/project-elderly-kingdom1.jpg",

      categories: [filters.WEB],
    },
    {
      title: "Food Ordering System",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "Food Ordering System is the extend of Elderly Kingdom. Since we find out some nursing home need to deliever the meals to different elders, we decide to make a extension for the last web. We used PHP, SQL, HTML5, Javascript, CSS to develop this website. The users (Nurse and caregiver) can use this web to order food from the kitchen in the nursing house. Moreover, the chef can edit the dishes and the menu for the elder and the nurse.",
        client: "",
        technologies: "PHP, SQL, HTML, Javascript, CSS",
        industry: "POS, sales system, food ordering",
        date: "April, 2020",
        url: {
          name: "",
          link: "",
        },
        sliderImages: [
          "images/projects/project-food-ordering-system2.jpg",
          "images/projects/project-food-ordering-system3.jpg",
          "images/projects/project-food-ordering-system4.jpg",
        ],
      },

      thumbImage: "images/projects/project-food-ordering-system1.jpg",

      categories: [filters.WEB],
    },
    {
      title: "Search Tool Web",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "This is a little web that I developed by using HTML and CSS. This web is about what is a search tools and help people to know more about it.",
        client: "",
        technologies: "HTML, CSS",
        industry: "Personal Project",
        date: "May, 2017",
        url: {
          name: "search-tool-web",
          link: "https://search-tool-web.vercel.app/index.html",
        },
        sliderImages: [
          "images/projects/project-search-tool2.jpg",
          "images/projects/project-search-tool3.jpg",
        ],
      },

      thumbImage: "images/projects/project-search-tool1.jpg",

      categories: [filters.WEB],
    },
    {
      title: "Encryption Program",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "This is a Java project I code and it is a small program that help me to understand how to encryption a string. I can know more about encryption and decryption.",
        client: "",
        technologies: "Java",
        industry: "Cybersecurity",
        date: "September, 2020",
        url: {
          name: "GitHub",
          link: "https://github.com/dennisisk/encryption-program",
        },

        sliderImages: [
          "images/projects/project-encryption1.jpg",
          "images/projects/project-encryption2.jpg",
        ],
      },

      thumbImage: "images/projects/project-encryption3.jpg",

      categories: [filters.SOFTWARE],
    },
    {
      title: "Recipe Menu App",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "This is my first app. My groupmates and I tried to make a prototype of a recipe app. We are using Java, Android Studio, Photoshop and SQL for the database to make this app. People can browse this app to find out some new recipe. Also, there are a submission tab for them to submit their recipes. Users can use the discussion section to post some opinions about the recipe.",
        client: "",
        technologies: "Android, Java, Photoshop, SQL",
        industry: "Cooking/Dishes",
        date: "July, 2021",
        url: {
          name: "GitHub",
          link: "https://github.com/dennisisk/MenuApps",
        },
        sliderImages: [
          "images/projects/project-menu-app2.jpg",
          "images/projects/project-menu-app3.jpg",
          "images/projects/project-menu-app4.jpg",
        ],
      },

      thumbImage: "images/projects/project-menu-app1.jpg",

      categories: [filters.APP],
    },
    {
      title: "Little mobile apps game",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "This is a small mobile app game developed by me. I used Android Studio and Java to develop this side-scrolling fighter shooting game. The image and the animation are also made by me. In this game, you need to control the fighter to shoot down the birds. If you crash into the bird or the birds pass through your side, you will lose. I made some features about the app that will record your highest score and the game will be harder after you complete a level.",
        client: "",
        technologies: "Android, Java, Photoshop, Animation",
        industry: "Game",
        date: "December, 2021",
        url: {
          name: "GitHub",
          link: "https://github.com/dennisisk/Game-Project",
        },
        sliderImages: [
          "images/projects/project-app-game2.jpg",
          "images/projects/project-app-game3.jpg",
        ],
      },

      thumbImage: "images/projects/project-app-game1.jpg",

      categories: [filters.APP],
    },
    {
      title: "ATM simulator",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "This is a ATM interface developed by me. I used Java to develop this little program. It simulates the ATM interface. You can try to add a new account and login to it. It simulates most of the function of an ATM, such as, deposit, withdraw cash and pay your bill.",
        client: "",
        technologies: "Java",
        industry: "Finance",
        date: "April, 2023",
        url: {
          name: "GitHub",
          link: "https://github.com/dennisisk/ATM-interface",
        },
        sliderImages: [
          "images/projects/project-atm2.jpg",
        ],
      },

      thumbImage: "images/projects/project-atm1.jpg",

      categories: [filters.SOFTWARE],
    },
    {
      title: "Snake game",
      type: types.DOCUMENT,
      document: {
        projectInfo:
          "This is a small java project, Snake game. After my relocation to Toronto, I try to create some small project. This is one of them.",
        client: "",
        technologies: "Java, Photoshop",
        industry: "Game",
        date: "June, 2023",
        url: {
          name: "GitHub",
          link: "https://github.com/dennisisk/Snake-game",
        },
        sliderImages: [
          "images/projects/project-snake2.jpg",
          "images/projects/project-snake3.jpg",
        ],
      },

      thumbImage: "images/projects/project-snake1.jpg",

      categories: [filters.SOFTWARE],
    },
  ];

  // initialize an Isotope object with configs
  useEffect(() => {
    isotope.current = new Isotope(".portfolio-filter", {
      itemSelector: ".filter-item",
      layoutMode: "masonry",
      originLeft: !isRtl,
    });

    // cleanup
    return () => {
      isotope.current.destroy();
    };
  }, []);

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: `*` })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => setFilterKey(key);

  const getKeyByValue = (value) => {
    return Object.keys(filters).find((key) => filters[key] === value);
  };

  const getFilterClasses = (categories) => {
    if (categories.length > 0) {
      let tempArray = [];
      categories.forEach((category, index) => {
        tempArray.push(getKeyByValue(category));
      });
      return tempArray.join(" ");
    }
  };

  return (
    <>
      <section id="portfolio" className={"section bg-light"}>
        <div className={"container"}>
          {/* Heading */}
          <p className="text-center mb-2 wow fadeInUp">
            <span className="bg-primary text-dark px-2">Portfolio</span>
          </p>
          <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
            Some of my most recent projects
          </h2>
          {/* Heading end*/}
          {/* Filter Menu */}
          <ul
            className={
              "portfolio-menu nav nav-tabs fw-600 justify-content-start justify-content-md-center border-bottom-0 mb-5 wow fadeInUp"
            }
          >
            <li className="nav-item">
              <button
                className={"nav-link " + (filterKey === "*" ? "active" : "")}
                onClick={handleFilterKeyChange("*")}
              >
                All
              </button>
            </li>
            {Object.keys(filters).map((oneKey, i) => (
              <li className="nav-item" key={i}>
                <button
                  className={
                    "nav-link " + (filterKey === oneKey ? "active" : "")
                  }
                  onClick={handleFilterKeyChange(oneKey)}
                >
                  {filters[oneKey]}
                </button>
              </li>
            ))}
          </ul>
          {/* Filter Menu end */}
          <div className="portfolio wow fadeInUp">
            <div className="row portfolio-filter filter-container g-4">
              {projectsData.length > 0 &&
                projectsData.map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      getFilterClasses(project.categories)
                    }
                    key={index}
                  >
                    <div className="portfolio-box">
                      <div className="portfolio-img">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div
                          className="portfolio-overlay"
                          onClick={() => {
                            setSelectedProjectDetails(projectsData[index]);
                            setIsOpen(true);
                          }}
                        >
                          <button className="popup-ajax stretched-link border-0 p-0 ">
                            {" "}
                          </button>
                          <div className="portfolio-overlay-details">
                            <p className="text-primary text-8">
                              {project.type === types.DOCUMENT && (
                                <i className="fas fa-file-alt"></i>
                              )}
                              {project.type === types.IMAGE && (
                                <i className="fas fa-image"></i>
                              )}
                              {project.type === types.VIDEO && (
                                <i className="fas fa-video"></i>
                              )}
                            </p>
                            <h5 className="text-white text-5">
                              {project?.title}
                            </h5>
                            <span className="text-light">Category</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
      {/* Modal */}
      {isOpen && (
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          setIsOpen={setIsOpen}
        ></ProjectDetailsModal>
      )}
    </>
  );
};

export default Portfolio;
